export default (playerUrl, options) => {
  let mod = playerUrl.indexOf('?') === -1 ? '?' : '&';
  for (let key in options) {
    playerUrl += mod + key + '=' + options[key];
    mod = '&';
  }
  return playerUrl;
};
